export default class AuthUserDTO {
  constructor(uid, name, email, emailVerified, accessToken) {
    this.uid = uid
    this.name = name
    this.email = email
    this.emailVerified = emailVerified
    this.accessToken = accessToken
  }
}
